import React from "react";
import { Link } from "react-router-dom";

export const AtlasMark = ({ size = 34, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="atlasg" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0f2740" />
        <stop offset="0.5" stopColor="#14395e" />
        <stop offset="1" stopColor="#5b738a" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="25" r="17" stroke="url(#atlasg)" strokeWidth="2.5" fill="none" />
    <ellipse cx="32" cy="25" rx="8" ry="17" stroke="url(#atlasg)" strokeWidth="1.6" fill="none" />
    <line x1="15" y1="25" x2="49" y2="25" stroke="url(#atlasg)" strokeWidth="1.6" />
    <path d="M22 47 L32 40 L42 47" stroke="url(#atlasg)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M26 54 Q32 44 38 54" stroke="url(#atlasg)" strokeWidth="3" strokeLinecap="round" fill="none" />
    <path d="M38 33 L46 15 L44 24 L52 20 L40 40" stroke="url(#atlasg)" strokeWidth="2.4" strokeLinejoin="round" strokeLinecap="round" fill="none" />
  </svg>
);

export const AtlasLogo = ({ compact = false }) => (
  <Link to="/" data-testid="atlas-logo" className="flex items-center gap-2.5 group">
    <AtlasMark size={compact ? 30 : 36} />
    <div className="leading-none">
      <div className="font-display font-bold tracking-tight text-[hsl(var(--atlas-navy))] text-lg sm:text-xl">
        ATLAS <span className="text-[hsl(var(--atlas-steel))]">ADVISORY</span>
      </div>
      {!compact && (
        <div className="text-[10px] uppercase tracking-[0.2em] text-[hsl(var(--atlas-steel))] mt-0.5">
          Citizenship &amp; Residency
        </div>
      )}
    </div>
  </Link>
);
